/**
 * UI控件库 
 * @module UI
 */

;(function (ui,$) {
    "use strict";
    /**
     * <h3>步骤条 beta</h3>
     * <a href="../../ui_control/bui.stepbar.html" target="_blank">demo</a> <br>
     * {{#crossLink "bui.stepbar/option"}}{{/crossLink}}: 获取设置参数 <br>
     * {{#crossLink "bui.stepbar/widget"}}{{/crossLink}}: 获取依赖控件 <br>
     * {{#crossLink "bui.stepbar/value"}}{{/crossLink}}: 设置第几步,跟获取当前在第几步 <br>
     * {{#crossLink "bui.stepbar/prev"}}{{/crossLink}}: 上一步 <br>
     * {{#crossLink "bui.stepbar/next"}}{{/crossLink}}: 下一步 <br>
     *  @namespace bui
     *  @class stepbar
     *  @constructor 
     *  @param {object} option  
     *  @param {string} option.id [控件id]    
     *  @param {array} option.data [ 步骤的内容 例如:[{ title:"",subtitle:"",content:""}] ] 
     *  @param {string} option.data.title [ 步骤的标题  ] 
     *  @param {string} [option.data.subtitle] [ 步骤的子标题  ] 
     *  @param {string} [option.data.content] [ 步骤的内容  ] 
     *  @param {string} [option.handle] [点击的区域,属于循环的那部分]  
     *  @param {boolean} [option.click] [允许点击时候修改对应的激活状态]
     *  @param {function} [option.callback] [ 点击按钮的回调 ]  
     *  @example
     * 
     *   html:
     *
            <div id="step" class="bui-stepbar"></div>
     *      
     *   js: 
     *   
            //初始化控件
            var uiStepbar = bui.stepbar({
                id: "#step",
                data: [{
                    title: "预立项申请",
                    subtitle: "2016-04-2 10:30",
                    content: "成功创建申请,已经提交至XX部门经理审批,请耐心等待"
                },{
                    title: "立项审批",
                    subtitle: "2016-04-21 10:30",
                    content: "审批完成,资料递交中"
                }]
            });

            //激活第2步
            uiStepbar.value(1);
     *
     */
    ui.stepbar = function(option){

        //默认配置
        var config = {
            id: null,
            handle: ".bui-stepbar-cell",
            click: true,
            data: [],                   
            callback: null              
        }
        //方法
        var module = {
            value: value,
            next: next,
            prev: prev,
            widget: widget,
            option: options,
            config: param,
            init: init
        };
        //用于option方法的设置参数
        var param = module.config = $.extend(true,{}, config, ui.config.stepbar, option );

        var id ,
            $id ,
            nowIndex,
            $handle ;

        //如果有id 就会执行初始化
        if( param.id ){

            init(param);
        }else{
            ui.hint('id 为必填项, 例如:{ id: ""}')
        }


        //初始化
        function init (option) {
            option = option || param;
            
            if( option.id ){
                $id = ui.obj(option.id);
            }else{
                ui.hint("stepbar id不能为空");
                return;
            }

            //option获取新参数使用
            param = module.config = option;

            var tpl = template(option.data) ;

            $(option.id).html(tpl);

            $handle = $id.children();

            //绑定按钮事件
            bind(option);
            
            
            return this;
        }


        //模板
        function template (data) {
            
            var html = '';

            $( data ).each(function (i,item) {
                html +='<div class="bui-stepbar-cell">';
                html +='    <span class="bui-stepbar-dot"></span>';
                html +='    <div class="bui-stepbar-text">';
                if( item.title ){

                html +='        <h3>'+item.title+'</h3>';
                }
                if( item.subtitle ){

                html +='        <p class="bui-stepbar-time">'+ item.subtitle +'</p>';
                }
                if( item.content ){

                html +='        <p class="bui-stepbar-desc">'+ item.content+'</p>';
                }
                html +='    </div>';
                html +='</div>';
            })

            return html;
        };

        //绑定事件
        function bind (option) {
            
            $id.off("click.bui",option.handle).on("click.bui",option.handle,function (e) {
                if( option.click ){

                    var index = $(this).index();

                        //激活当前步骤
                        value(index);
                }

                option.callback && option.callback.call(this,e,module);
            })

            return this;
        }

        /**
         * 设置或者获取值
         *  @method value
         *  @param {number} [index] [设置值]
         *  @example 
            
            //设置值
            uiStepbar.value(1);
            
            //获取值
            var val = uiStepbar.value();
                
         */
        function value (index) {
            
            if( typeof index === "number" ){
                
                if( index >= ($handle.length-1) ){
                    index = ($handle.length-1) ;
                }else if( index < 0 ){
                    index = 0 ;
                }else{
                    index = index;
                };

                $handle.each(function (i,item) {
                    if( i < index ){
                        $(item).removeClass('active').addClass('visited');
                    }
                    if( i == index ){
                        $(item).removeClass('visited').addClass('active');
                    }
                    if ( i > index ){
                        $(item).removeClass('visited active');
                    }
                })

                return index;

            }else{

                var index = $id.children(".active").index();

                return index;
            }
        }

        /**
         * 下一步
         *  @method next
         *  @example 
            
            //下一步
            uiStepbar.next();
            
         */
        function next() {
            
            var val = value() + 1;

            return value( val );
        }
        /**
         * 上一步
         *  @method prev
         *  @example 
            
            //上一步
            uiStepbar.prev();
            
         */
        function prev() {
            
            var val = value()-1;

            return value( val );
        }

        /**
         * 获取依赖的控件
         *  @method widget
         *  @param {string} [name] [ 依赖控件名 ]
         *  @example 
            
            //获取依赖控件
            var uiStepbarWidget = uiStepbar.widget();
            
                
         */
        function widget(name) {
            var control = {};
            return ui.widget.call(control,name);
        };
        /**
         * 获取设置参数
         *  @method option
         *  @param { string | object } [key] [ 不传则获取所有参数, 类型为string,没有第2个参数则获取某个参数 ]
         *  @param { string | number | boolean | function } [value] [ 设置参数的时候要传,设置多个参数不用传,获取参数的时候也不用传 ]
         *  @chainable
         *  @example 
            
            
            //获取所有参数
             //获取所有参数
            var option = uiStepbar.option();

            //获取某个参数
            var id = uiStepbar.option( "id" );

            //修改一个参数
            uiStepbar.option( "click",false );

            //修改多个参数
            uiStepbar.option( {"click":false} );
                
         */
        function options (key,value) {

           return ui.option.call(module,key,value);
        }
        
        return module;
    };

    return ui;

})( bui || {}, libs );
